(function() {
    const StoricoModificheContattiService = function(
        $http,
        CONSTANTS,
        generalSrvc,
        labelSrvc
    ) {
        this.openLista = (codiceUtente) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CREDENZIALI.STORICO_CONTATTI + codiceUtente
            });
        };
    };

    StoricoModificheContattiService.$inject = [
        '$http',
        'Mitom_CONSTANTS',
        'MitomGenralSrvc',
        'MitomLabelSrvc'
    ];

    angular
        .module('cbl.mitomanager.wa')
        .service('MitomStoricoModificheContattiService', StoricoModificheContattiService);
})();